<form [formGroup]="mfaForm" (ngSubmit)="onSubmit()" class="flex flex-col space-y-5">
  <div>
    <h3 class="text-xl font-bold text-gray-800 mb-2">Set up multifactor authentication</h3>
    <p class="text-sm text-gray-600">
      Scan the QR code with your authenticator app and enter the 6-digit code.
    </p>
  </div>

  <div *ngIf="isLoadingSetup" class="flex items-center justify-center py-8 text-sm text-gray-500">
    Loading MFA setup...
  </div>

  <ng-container *ngIf="!isLoadingSetup && setupData">
    <div class="flex flex-col items-center space-y-2">
      <img
        *ngIf="setupData.qr_code"
        [src]="setupData.qr_code"
        alt="MFA QR code"
        class="h-36 w-36 border border-gray-200 rounded-lg p-1.5"
      />
      <div class="text-center max-w-full">
        <span class="block text-xs font-semibold text-gray-500">Manual key</span>
        <span class="manual-key font-mono text-xs text-gray-700">{{ setupData.manual_key }}</span>
      </div>
    </div>

    <div class="flex flex-col space-y-1">
      <label class="px-2 text-sm font-semibold text-gray-500">Verification code</label>
      <app-mfa-code-input formControlName="code"></app-mfa-code-input>
      <p
        class="text-center text-xs"
        [class.text-gray-500]="!challengeExpired"
        [class.text-red-600]="challengeExpired"
      >
        <span *ngIf="!challengeExpired">Setup expires in {{ formattedRemainingTime }}.</span>
        <span *ngIf="challengeExpired">Setup expired. Please restart login.</span>
      </p>
      <div
        *ngIf="mfaForm.get('code')?.errors && mfaForm.get('code')?.touched"
        class="text-red-500 text-sm"
      >
        Enter a 6-digit numeric code.
      </div>
    </div>

    <button
      type="submit"
      [disabled]="isSubmitting || challengeExpired"
      class="w-full inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg shadow-md hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
    >
      {{ isSubmitting ? 'Verifying...' : 'Enable MFA' }}
    </button>
  </ng-container>

  <div *ngIf="errorMessages.length > 0" class="text-red-500 text-sm">
    <ul class="list-disc list-inside">
      <li *ngFor="let error of errorMessages">{{ error }}</li>
    </ul>
  </div>

  <div class="flex justify-between text-sm">
    <button type="button" class="text-blue-600 hover:underline" (click)="back.emit()">
      Back to login
    </button>
    <button
      type="button"
      class="text-blue-600 hover:underline disabled:text-gray-400 disabled:no-underline"
      (click)="retrySetup()"
      [disabled]="isLoadingSetup || challengeExpired"
    >
      Generate new QR code
    </button>
  </div>
</form>
